import model from 'modules/webhook/webhookModel';

const { fields } = model;

export default [
  fields.id,
  fields.url,
  fields.company,
  fields.enable,
  fields.createdAt,
  fields.updatedAt
];
